import { takeLatest, put } from 'redux-saga/effects';

import {
    CREATE_HATCH,
    UPDATE_HATCH,
    DELETE_HATCH,
    HATCH_PIN,
    SAVE_VIEW_HATCH
} from './constants';

import {
    requestCreateHatch,
    requestUpdateHatch,
    requestDeleteHatch,
    requestPinHatch,
    requestSaveViewHatch
} from './api';

import {
    createHatchSuccess,
    updateHatchSuccess,
    deleteHatchSuccess,
    pinHatchSuccess,
    saveViewHatchSuccess
} from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{hatch, type}>>}
 */
function* createHatch( actionObj ) {
    const requestHatch = {
        calendar_id: actionObj.calendar_id,
        type: actionObj.typeHatch,
        background: actionObj.bgColor
    };
    const hatch = yield requestCreateHatch( requestHatch );
    if ( hatch ) {
        yield put( createHatchSuccess( hatch ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{hatch, type}>>}
 */
function* updateHatch( actionObj ) {
    const dataHatch = {
        calendar_id: actionObj.calendar_id,
        ...actionObj.value
    };
    const newHatch = yield requestUpdateHatch( actionObj.hatchID, dataHatch );
    if ( newHatch ) {
        yield put( updateHatchSuccess( newHatch ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{hatches, type}>>}
 */
function* deleteHatch( actionObj ) {
    const hatches = yield requestDeleteHatch( actionObj.hatchID );
    if ( hatches ) {
        yield put( deleteHatchSuccess( hatches ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{hatch, type}>>}
 * @constructor
 */
function* PinHatch( actionObj ) {
    const updatePinHatch = yield requestPinHatch( actionObj.hatchID );
    if ( updatePinHatch ) {
        yield put( pinHatchSuccess( updatePinHatch ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{data, type}>>}
 */
function* saveViewHatch( actionObj ) {
    const data = yield requestSaveViewHatch( actionObj.id );
    if ( data ) {
        yield put( saveViewHatchSuccess( data ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchCalendarHatch() {
    yield takeLatest( CREATE_HATCH, createHatch );
    yield takeLatest( UPDATE_HATCH, updateHatch );
    yield takeLatest( DELETE_HATCH, deleteHatch );
    yield takeLatest( HATCH_PIN, PinHatch );
    yield takeLatest( SAVE_VIEW_HATCH, saveViewHatch );
}

export default watchCalendarHatch;